import en from './en';
import nl from './nl';

export default {
  en,
  nl,
};



// WEBPACK FOOTER //
// ./src/app/locale/index.js